import { useEffect, useState, useRef } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "../assets/searchIcon.svg";
import { ReportServices } from "../services/ReportServices";
import { HospitalServices } from "../services/HospitalServices";
import { NotificationServices } from "../services/NotificationServices";
import Select from "react-select";
import CustomPagination from "../utils/paginationUtils";
import { CircularProgress } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import formatDateTimeLocal from "../utils/formatDateTimeUtil";
import "./Report.scss";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import { InterUserMangementServices } from "../services/InternalUserMangementServices";
const CcReportDocumentTypeWise = () => {
  const [loading, setLoading] = useState(false);
  const [caseStageData, setCaseStageData] = useState(null);
  const [users, setUsers] = useState(null);
  const [hospitalList, setHospitalList] = useState([]);
  const [hospitalId, setHospitalId] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [teamUserList, setTeamUserList] = useState(null);
  const [pageNum, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [subStatusList, setSubStatusList] = useState([]);
  const [status, setStatus] = useState("");
  const [assignedUser, setAssignedUser] = useState("");
  const [stageTimeColor, setStageTimeColor] = useState(null);
  const [docType, setDocType] = useState("ADMISSION");
  const [diffStageCount, setDiffStageCount] = useState(null);
  const [caseType, setCaseType] = useState("");
  const [tableHeader, setTableHeader] = useState(null);
  const [tableHeaderTwo, setTableHeaderTwo] = useState(null);
  const [allCasesData, setAllCasesData] = useState({
    totalCases: "",
    totalCompleted: "",
    totalPending: "",
  });
  const [filteredCasesData, setFilteredCasesData] = useState({
    filteredCases: "",
    filteredCompleted: "",
    filteredPending: "",
  });
  const searchTimeRef = useRef();
  let prevDate = new Date();
  prevDate.setDate(prevDate.getDate() - 1);
  const [startDate, setStartDate] = useState(
    formatDateTimeLocal(prevDate), // one day before date
  );
  const [endDate, setEndDate] = useState(formatDateTimeLocal(new Date())); //current date
  const limit = 10;
  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
  };

  // Check if datetime-local is supported (Safari does not support it fully)
  const supportsDateTimeLocal = () => {
    if (typeof document === "undefined") return false;
    const input = document.createElement("input");
    input.setAttribute("type", "datetime-local");
    input.value = "test";
    return input.value !== "test"; // true = supported
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
  };
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearTimeout(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };
  const getTime = (diffInS) => {
    const diffInMs = diffInS * 1000;
    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (diffInMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffInMs % (1000 * 60)) / 1000);

    return `${days > 0 ? days + "D " : ""}${hours > 0 ? hours + "H " : ""} ${
      minutes > 0 ? minutes + "M" : ""
    } ${!days && !hours && !minutes ? seconds + " S" : ""}`;
  };

  const extractDateTime = (timestamp) => {
    const dateObj = new Date(timestamp);
    const time = dateObj.toLocaleTimeString();
    const [year, month, day] = timestamp.slice(0, 10).split("-");
    return `${day}/${month}/${year} ${time}`;
  };

  const formatDate = (date) => {
    date = new Date(date);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed, so we add 1
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const getOverAllStatusCount = (caseData, color) => {
    let count = 0;
    for (let status of subStatusList) {
      if (
        caseData?.submasterstagestatuses[
          status?.commandCenterStageText || status?.commandCenterStageStatus
        ]?.colorData?.bgColor.includes(color)
      ) {
        count++;
      }
    }
    return `${count} `;
  };
  const getUsersDetails = async () => {
    try {
      const response = await ReportServices.getUsers();
      setUsers(response.data.users);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getPendingStatusCount = (caseData) => {
    let count = 0;
    const updatedSubstatusList = subStatusList?.filter(
      (status) => status.id !== 176 && status.id !== 999,
    );
    for (let status of updatedSubstatusList) {
      if (
        !caseData?.submasterstagestatuses[
          status?.commandCenterStageText || status?.commandCenterStageStatus
        ]?.processTime
      ) {
        count++;
      }
    }
    return count;
  };
  const getHospitalList = async () => {
    try {
      const response = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(response.data.list);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getSubStatusList = async () => {
    try {
      const response = await NotificationServices.getSubMasterStages(
        200,
        "main",
      );
      setSubStatusList(response?.data?.subMasterStages);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDefaultStageTimeColor = async () => {
    try {
      const response = await ReportServices.getDefaultStageTimeColor();
      setStageTimeColor(response.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getDifferentStageCount = async () => {
    try {
      const res = await ReportServices.getCcDiffStageCaseCount(
        hospitalId,
        startDate,
        endDate,
        searchKey,
        status,
      );
      console.log("diff stage count:", res?.data);
      setDiffStageCount(res?.data);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getProcessedCount = async () => {
    try {
      const response = await ReportServices?.getProcessedStageCount(
        startDate,
        endDate,
        hospitalId,
      );
      console.log("processed:", response?.data);
      setTableHeader(response?.data?.customReport);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getProcessedCountNew = async () => {
    try {
      const response = await ReportServices?.getProcessedStageCountNew(
        startDate,
        endDate,
        hospitalId,
        docType,
        caseType,
      );
      console.log("processed new api:", response?.data);
      setTableHeaderTwo(response?.data?.customReport);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getTeamUsers = async () => {
    try {
      const response = await InterUserMangementServices.getTeamUser(
        100,
        1,
        "",
        1,
      );
      console.log("team name", response.data.teamUsers);
      setTeamUserList(response.data.teamUsers);
      console.log("Team user list", teamUserList);
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  const getCaseStageNewReport = async () => {
    setLoading(true);
    try {
      const response = await ReportServices.getCaseStageReport2(
        startDate,
        endDate,
        hospitalId,
        pageNum,
        status,
        searchKey,
        docType,
        assignedUser,
        caseType,
      );
      setAllCasesData({
        totalCases: response?.data?.totalCases,
        totalCompleted: response?.data?.totalCompleted,
      });
      setFilteredCasesData({
        filteredCases: response?.data?.totalFiltered,
        filteredCompleted: response?.data?.filteredCompleted,
      });
      setCaseStageData(response?.data?.report);
      setTotalPages(response?.data?.totalPages);
      console.log("table header 2", tableHeaderTwo);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setLoading(false);
  };
  useEffect(() => {
    // getCaseStageData();
    getCaseStageNewReport();
    getProcessedCountNew();
  }, [
    startDate,
    endDate,
    hospitalId,
    pageNum,
    status,
    searchKey,
    docType,
    assignedUser,
    caseType,
  ]);
  useEffect(() => {
    getDifferentStageCount();
    getProcessedCount();
  }, [startDate, endDate, hospitalId, searchKey]);
  useEffect(() => {
    getHospitalList();
    getSubStatusList();
    getDefaultStageTimeColor();
    getUsersDetails();
    getTeamUsers();
    // getProcessedCount();
  }, []);
  console.log("table header 2:", tableHeader, tableHeaderTwo);

  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  return (
    <div className="p-[32px] mt-[92px] w-full overflow-hidden">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Command Center Report
      </span>
      {/* <div className="flex gap-4  items-center">
        <text className="heading"> Total Report :</text>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          Cases -{" "}
          <span className="font-semibold">{allCasesData.totalCases}</span>
        </div>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          L1 Complete -{" "}
          <span className="font-semibold">
            {allCasesData?.totalCompleted?.["L1 COMPLETE"] || 0}
          </span>
        </div>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          L2 Complete -{" "}
          <span className="font-semibold">
            {(allCasesData?.totalCompleted["COMPLETE"] || 0) +
              (allCasesData?.totalCompleted["L2 COMPLETE"] || 0)}
          </span>
        </div>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          L3 Complete -{" "}
          <span className="font-semibold">
            {allCasesData?.totalCompleted["L3 COMPLETE"] || 0}
          </span>
        </div>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          L4 Complete -{" "}
          <span className="font-semibold">
            {allCasesData.totalCompleted["L4 COMPLETE"] || 0}
          </span>
        </div>
        <div style={{ borderRight: "2px solid #191919", paddingRight: "12px" }}>
          Total Completed -{" "}
          <span className="font-semibold">
            {allCasesData?.totalCompleted?.totalCompleted || 0}
          </span>
        </div>
        <div>
          Pending -{" "}
          <span className="font-semibold">
            {allCasesData.totalCases -
              (allCasesData?.totalCompleted?.totalCompleted || 0)}
          </span>
        </div>
      </div> */}

      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          <div>
            <label htmlFor="start-date">Start Date:</label>
            {supportsDateTimeLocal() && !isSafari ? (
              <input
                type="datetime-local"
                id="start-date"
                value={startDate}
                onChange={handleStartDateChange}
                max={formatDate(new Date())}
                style={{ border: "1px solid #E5E5E5" }}
                className="text-[#191919] appearance-none p-2 rounded-[8px]"
              />
            ) : (
              <div style={{ display: "flex", gap: "8px" }}>
                <input
                  type="date"
                  value={startDate?.slice(0, 10)}
                  onChange={(e) =>
                    handleStartDateChange({
                      target: {
                        value:
                          e.target.value +
                          "T" +
                          (startDate?.slice(11) || "00:00"),
                      },
                    })
                  }
                  max={formatDate(new Date())}
                  className="text-[#191919] p-2 rounded-[8px]"
                  style={{ border: "1px solid #E5E5E5" }}
                />
                <input
                  type="time"
                  value={startDate?.slice(11) || ""}
                  onChange={(e) =>
                    handleStartDateChange({
                      target: {
                        value:
                          (startDate?.slice(0, 10) || formatDate(new Date())) +
                          "T" +
                          e.target.value,
                      },
                    })
                  }
                  className="text-[#191919] p-2 rounded-[8px]"
                  style={{ border: "1px solid #E5E5E5" }}
                />
              </div>
            )}
          </div>

          <div>
            <label htmlFor="end-date">End Date:</label>
            {supportsDateTimeLocal() && !isSafari ? (
              <input
                type="datetime-local"
                id="end-date"
                value={endDate}
                onChange={handleEndDateChange}
                max={formatDate(new Date())}
                style={{ border: "1px solid #E5E5E5" }}
                className="text-[#191919] appearance-none p-2 rounded-[8px]"
              />
            ) : (
              <div style={{ display: "flex", gap: "8px" }}>
                <input
                  type="date"
                  value={endDate?.slice(0, 10)}
                  onChange={(e) =>
                    handleEndDateChange({
                      target: {
                        value:
                          e.target.value +
                          "T" +
                          (endDate?.slice(11) || "00:00"),
                      },
                    })
                  }
                  max={formatDate(new Date())}
                  className="text-[#191919] p-2 rounded-[8px]"
                  style={{ border: "1px solid #E5E5E5" }}
                />
                <input
                  type="time"
                  value={endDate?.slice(11) || ""}
                  onChange={(e) =>
                    handleEndDateChange({
                      target: {
                        value:
                          (endDate?.slice(0, 10) || formatDate(new Date())) +
                          "T" +
                          e.target.value,
                      },
                    })
                  }
                  className="text-[#191919] p-2 rounded-[8px]"
                  style={{ border: "1px solid #E5E5E5" }}
                />
              </div>
            )}
          </div>
          <Select
            name="hospitalId"
            isClearable
            options={hospitalList}
            getOptionLabel={(options) => {
              return options["name"];
            }}
            getOptionValue={(options) => {
              return options["id"];
            }}
            onChange={(item) => {
              // setPage(1);
              item ? setHospitalId(item.id) : setHospitalId("");
            }}
            value={hospitalList.filter((item) => item.id === hospitalId)}
            placeholder="FILTER HOSPITAL WISE"
          />
          <Select
            name="user"
            isClearable
            options={teamUserList}
            getOptionLabel={(option) => {
              const roleName =
                option.userrolemappings && option.userrolemappings.length > 0
                  ? option.userrolemappings[0].role?.roleName || ""
                  : "";
              return `${option.fullName}${roleName ? " - " + roleName : ""}`;
            }}
            getOptionValue={(option) => option.id}
            onChange={(item) => {
              item ? setAssignedUser(item.id) : setAssignedUser("");
            }}
            value={teamUserList?.filter((item) => item.id === assignedUser)}
            placeholder="FILTER USER WISE"
          />
          <Select
            name="caseType"
            isClearable
            options={[
              { value: "SURGICAL", label: "SURGICAL" },
              { value: "CONSERVATIVE", label: "CONSERVATIVE" },
              { value: "DAYCARE", label: "DAYCARE" },
            ]}
            getOptionLabel={(option) => option.label}
            getOptionValue={(option) => option.value}
            onChange={(item) => setCaseType(item ? item.value : "")}
            value={[
              { value: "SURGICAL", label: "SURGICAL" },
              { value: "CONSERVATIVE", label: "CONSERVATIVE" },
              { value: "DAYCARE", label: "DAYCARE" },
            ].filter((option) => option.value === caseType)}
            placeholder="FILTER CASE TYPE WISE"
          />
        </div>
      </div>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />
      <div>
        <h2>Total process stages</h2>
        {/* <div className="text-sm grid grid-cols-5 gap-4 justify-start items-start  mt-4 p-4 border border-solid border-[#e5e5e5] rounded-xl">
          {tableHeader &&
            tableHeader
              ?.filter((header) =>
                header.mainStage
                  .toLowerCase()
                  .includes(
                    docType.toLowerCase() == "discharge"
                      ? "claim"
                      : docType.toLowerCase()
                  )
              )
              ?.map((header, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      borderRight:
                        idx !== 4 && idx != 9 ? "2px solid #191919" : "",
                      textAlign: "center",
                      // paddingRight: "12px",
                      // height: "40px",
                    }}
                    title={header?.mainStageFullName}
                  >
                    {header?.stageShortName || header?.mainStageFullName} -{" "}
                    <span className="font-semibold">
                      {header?.totalCaseCount}
                    </span>
                  </div>
                );
              })}
        </div> */}
      </div>
      <div className="flex justify-between items-center mt-2">
        <div className="flex gap-5 mb-2">
          <div
            className={` ${
              docType == "ADMISSION"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017C57] bg-white shadow-md"
            }  border border-solid border-[#017C57] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setDocType("ADMISSION");
              setPage(1);
            }}
          >
            Admission ({diffStageCount?.admission})
          </div>
          <div
            className={` ${
              docType == "ENHANCEMENT"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017c57] bg-white shadow-md"
            }  border border-solid border-[#017c57] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setDocType("ENHANCEMENT");
              setPage(1);
            }}
          >
            Enhancement ({diffStageCount?.enhancement})
          </div>
          <div
            className={` ${
              docType == "DISCHARGE"
                ? "text-white bg-[#017C57] shadow-lg"
                : "text-[#017C57] bg-white shadow-md"
            }  border border-solid border-[#017C57] px-5 py-3 rounded-full cursor-pointer`}
            onClick={() => {
              setDocType("DISCHARGE");
              setPage(1);
            }}
          >
            Discharge/Claim ({diffStageCount?.discharge})
          </div>
        </div>
        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="w-[270px] flex gap-1 items-center py-1 px-2 rounded-[4px]"
        >
          <img src={SearchIcon} alt="search-icon" />
          <input
            type="text"
            onChange={handleSearch}
            className="w-full border-none outline-none"
            placeholder="Patient Name / Beneficiary Number"
          />
        </div>
      </div>

      <div className="text-sm grid grid-cols-5 gap-4 justify-start items-start  mt-4 p-4 border border-solid border-[#e5e5e5] rounded-xl">
        {tableHeaderTwo &&
          tableHeaderTwo
            ?.filter((header) =>
              header.mainStage
                .toLowerCase()
                .includes(
                  docType.toLowerCase() == "discharge"
                    ? "claim"
                    : docType.toLowerCase(),
                ),
            )
            ?.map((header, idx) => {
              return (
                <div
                  key={idx}
                  style={{
                    borderRight:
                      idx !== 4 && idx != 9 ? "2px solid #191919" : "",
                    textAlign: "center",
                  }}
                  title={header?.mainStageFullName}
                  className="flex items-center justify-center relative"
                >
                  <span>
                    {header?.stageShortName || header?.mainStageFullName} -{" "}
                    <span className="font-semibold">
                      {header?.stageCaseCount}
                    </span>
                  </span>
                  {header.subStages && header.subStages.length > 0 && (
                    <div className="group relative ml-2">
                      <InfoOutlinedIcon
                        style={{
                          color: "#017C57",
                          fontSize: "18px",
                          cursor: "pointer",
                        }}
                      />
                      <div className="absolute left-1/2 -translate-x-1/2 mt-2 z-10 hidden group-hover:block bg-white border border-gray-200 rounded shadow-xl min-w-[220px] p-2 text-left">
                        {header.subStages.map((sub, i) => (
                          <div
                            key={i}
                            className="py-1 text-xs flex justify-between border-b last:border-none"
                          >
                            <span>{sub.stage}</span>
                            <span className="font-semibold">
                              {sub.stageCaseCount}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
      </div>

      <div
        style={{ border: "1px solid #e4e4e4", marginTop: "24px" }}
        className="rounded-[16px] p-5 overflow-x-scroll"
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(32, 1fr)",
          }}
          className="gap-0.5 px-1"
        >
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[100px] p-1">
            <div>Created Date</div>
          </div>
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[100px] p-1">
            {" "}
            <div>Register Date</div>
          </div>
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[200px] p-1">
            {" "}
            <div>Status</div>
          </div>
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[150px] p-1">
            {" "}
            <div>Hospital Name</div>
          </div>
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[150px] p-1">
            {" "}
            <div>Patient Name</div>
          </div>
          <div className="text-sm font-semibold text-center bg-[#e5e5e5] w-[150px] p-1">
            {" "}
            <div>Processed Time</div>
          </div>
          {/* <div className="text-sm font-medium text-center bg-[#F5F5F5] w-[150px] p-1">
            {" "}
            <div>Overall Status</div>
          </div> */}

          {subStatusList
            ?.filter(
              (status) =>
                status.id !== 999 &&
                status.commandCenterStageStatus
                  .toLowerCase()
                  .includes(
                    docType.toLowerCase() == "discharge"
                      ? "claim"
                      : docType.toLowerCase(),
                  ),
            )
            ?.map((status, idx) => {
              return (
                <div
                  key={idx}
                  className="text-sm font-medium text-start bg-[#F5F5F5] w-[150px] p-1"
                >
                  {" "}
                  <div className="flex justify-between items-start">
                    <span
                      title={
                        status?.mainStageFullName ||
                        status?.commandCenterStageStatus
                      }
                    >
                      {status?.stageShortName}
                    </span>

                    <div className="group relative">
                      <InfoOutlinedIcon
                        style={{
                          color: "#017C57",
                          fontSize: "16px",
                          cursor: "pointer",
                        }}
                      />
                      <div
                        style={{ border: "1.5px solid #D4D4D4" }}
                        className="text-sm hidden group-hover:block absolute top-5 -left-[130px] z-10 w-[160px] rounded-[8px]"
                      >
                        {stageTimeColor?.colorData[
                          stageTimeColor?.subMainStageIdPair[
                            status?.commandCenterStageStatus?.toLowerCase()
                          ]
                        ]?.map((data, idx) => {
                          return (
                            <div
                              key={idx}
                              style={{
                                color: data.textColor,
                                backgroundColor: data.bgColor,
                                padding: "8px",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                              className="first:rounded-t-[8px] last:rounded-b-[8px] text-sm"
                            >
                              <div>{data.type}</div>
                              <div>
                                {getTime(Number(data.startTime) * 60)} -
                                {idx < 3 && getTime(Number(data.endTime) * 60)}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        {loading ? (
          <div className="flex justify-center mt-5">
            <CircularProgress />
          </div>
        ) : (
          <div>
            {caseStageData?.length > 0 ? (
              caseStageData?.map((caseData, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      width: "fit-content",
                      display: "grid",
                      gridTemplateColumns: "repeat(32, 1fr)",
                      border: "1px solid #E4E4E4",
                    }}
                    className="text-sm gap-0.5 py-3 px-1  mt-2 rounded-[8px]"
                  >
                    <div className="w-[100px] flex justify-center items-center  text-center">
                      {caseData?.createdAt
                        ? extractDateTime(caseData?.createdAt)
                        : "--"}
                    </div>
                    <div className="w-[100px] flex justify-center items-center bg-[#F5F5F5] text-center">
                      {caseData?.patient?.registeredDate
                        ? extractDateTime(caseData?.patient?.registeredDate)
                        : "--"}
                    </div>
                    <div className=" w-[200px] flex justify-center items-center text-center ">
                      {caseData?.status.toLowerCase().includes("complete") ? (
                        <span className="text-[#017C57] bg-[#CDFAF4] w-full h-full p-2">
                          {caseData?.status}
                        </span>
                      ) : (
                        <span
                          className=" bg-[#FFE227] h-full p-2 text-ellipsis whitespace-nowrap overflow-hidden"
                          title={
                            caseData?.submasterstagestatuses?.currentStageText
                          }
                        >
                          Pending /{" "}
                          <span>
                            {caseData?.submasterstagestatuses?.currentStageText}
                          </span>
                        </span>
                      )}
                    </div>
                    <div
                      title={caseData?.hospital?.name}
                      className="w-[150px] flex justify-center items-center text-center bg-[#F5F5F5] "
                    >
                      {caseData.hospital?.name || "--"}
                    </div>
                    <div className="w-[150px] flex justify-center items-center text-center ">
                      {caseData.patient?.patientName || "--"}
                    </div>
                    <div className="w-[150px] flex justify-center items-center text-center bg-[#F5F5F5]">
                      {caseData.totalProcessTime
                        ? getTime(caseData.totalProcessTime)
                        : "--"}
                    </div>
                    {/* <div className="w-[150px] flex justify-center gap-1 items-center text-center text-[#B4B4B4]">
                      <span
                        className="bg-[#FF2828] text-white px-1 rounded-[4px]"
                        title="Critical"
                      >
                        {getOverAllStatusCount(caseData, "#FF8686")}
                      </span>
                      /
                      <span className="text-[#F76E0B]" title="Challenges">
                        {getOverAllStatusCount(caseData, "#FFE7D6")}
                      </span>
                      /
                      <span className="text-[#1B86EB]" title="Delay">
                        {getOverAllStatusCount(caseData, "#DAECF8")}
                      </span>
                      /
                      <span
                        className="bg-[#017C57] text-white px-1 rounded-[4px]"
                        title="On Track"
                      >
                        {getOverAllStatusCount(caseData, "#CDFAF4")}
                      </span>
                      /
                      <span className="text-[#FFCC00]" title="Pending">
                        {getPendingStatusCount(caseData)}
                      </span>
                    </div> */}

                    {subStatusList
                      ?.filter(
                        (status) =>
                          status.id !== 999 &&
                          status?.commandCenterStageStatus
                            ?.toLowerCase()
                            ?.includes(
                              docType.toLowerCase() == "discharge"
                                ? "claim"
                                : docType.toLowerCase(),
                            ),
                      )
                      ?.map((status, idx) => {
                        return (
                          <div
                            style={{
                              color:
                                caseData?.submasterstagestatuses[
                                  status?.commandCenterStageText ||
                                    status?.commandCenterStageStatus
                                ]?.colorData?.textColor ||
                                (status.id === 176 ? "#017C57" : "#191919"),
                              backgroundColor:
                                caseData?.submasterstagestatuses[
                                  status?.commandCenterStageText ||
                                    status?.commandCenterStageStatus
                                ]?.colorData?.bgColor ||
                                (status.id === 176 ? "#CDFAF4" : "#FFE77F "),
                            }}
                            className="w-[150px] flex items-center justify-center text-center"
                          >
                            {status.id === 75 &&
                            (caseData?.status.toLowerCase() === "complete" ||
                              caseData?.status.toLowerCase() === "l2 complete")
                              ? "COMPLETE"
                              : caseData?.submasterstagestatuses[
                                    status?.commandCenterStageText ||
                                      status?.commandCenterStageStatus
                                  ]?.processTime
                                ? getTime(
                                    caseData.submasterstagestatuses[
                                      status?.commandCenterStageText ||
                                        status?.commandCenterStageStatus
                                    ].processTime,
                                  )
                                : status.id === 176
                                  ? "NA"
                                  : "PENDING"}
                            {users &&
                              users[
                                caseData.submasterstagestatuses[
                                  status?.commandCenterStageText ||
                                    status?.commandCenterStageStatus
                                ]?.stages[0]?.assignedTo
                              ]}
                          </div>
                        );
                      })}
                  </div>
                );
              })
            ) : (
              <div className="text-center mt-5 text-xl font-bold">
                No Data Found
              </div>
            )}
          </div>
        )}
      </div>
      <div className="flex justify-center mt-5">
        <CustomPagination
          page={pageNum}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default CcReportDocumentTypeWise;
